/** Registers the RichTextLabel parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseRichTextLabel } from './parser';
const richTextLabelRegistration = {
    typeName: 'RichTextLabel',
    parser: parseRichTextLabel,
};
nodeRegistry.register(richTextLabelRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map